export default {
    "BAGUS_CABIN": {
        "id": "BAGUS_CABIN",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 24,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "BAGU_SAUCE"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18017,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "BUBBLE_CLIFF": {
        "id": "BUBBLE_CLIFF",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 6,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17974,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_200P": {
        "id": "CAVE_200P",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 12,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17981,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 13,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20450,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "CAVE_A": {
        "id": "CAVE_A",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 42,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DM_ENTRANCE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24886,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_B_E": {
        "id": "CAVE_B_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 1,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_B_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24845,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_B_W": {
        "id": "CAVE_B_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 1,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_B_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24844,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_C_E": {
        "id": "CAVE_C_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 2,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_C_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24846,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_C_W": {
        "id": "CAVE_C_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 2,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_C_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24847,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_D_E": {
        "id": "CAVE_D_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 4,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_D_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24850,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_D_W": {
        "id": "CAVE_D_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 4,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_D_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24851,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_E_N": {
        "id": "CAVE_E_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 3,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_E_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24848,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_E_S": {
        "id": "CAVE_E_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 3,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_E_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24849,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_F_E": {
        "id": "CAVE_F_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 5,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_F_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24852,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_F_W": {
        "id": "CAVE_F_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 5,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_F_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24853,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_I_N": {
        "id": "CAVE_I_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 7,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_I_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24857,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_I_S": {
        "id": "CAVE_I_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 7,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_I_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24856,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_J_E": {
        "id": "CAVE_J_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 6,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_J_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24854,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_J_W": {
        "id": "CAVE_J_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 6,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_J_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24855,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_K": {
        "id": "CAVE_K",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 43,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DM_EXIT"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24887,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_L_N": {
        "id": "CAVE_L_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 8,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_L_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24859,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_L_S": {
        "id": "CAVE_L_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 8,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_L_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24858,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_M_E": {
        "id": "CAVE_M_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 10,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_M_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24862,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_M_W": {
        "id": "CAVE_M_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 10,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_M_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24863,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_N_N": {
        "id": "CAVE_N_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_N_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24871,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_N_S": {
        "id": "CAVE_N_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_N_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24870,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_O_N": {
        "id": "CAVE_O_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 9,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_O_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24861,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_O_S": {
        "id": "CAVE_O_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 9,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_O_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24860,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_P_E": {
        "id": "CAVE_P_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 11,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_P_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24864,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_P_W": {
        "id": "CAVE_P_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 11,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_P_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24865,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_Q_E": {
        "id": "CAVE_Q_E",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 12,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_Q_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24866,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_Q_W": {
        "id": "CAVE_Q_W",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 12,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_Q_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24867,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_R_N": {
        "id": "CAVE_R_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 13,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_R_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24869,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "CAVE_R_S": {
        "id": "CAVE_R_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 13,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_R_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24868,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DAZZLE_LIFE": {
        "id": "DAZZLE_LIFE",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 57,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34376,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 57,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36755,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "DEATH_VALLEY_500P_BAG": {
        "id": "DEATH_VALLEY_500P_BAG",
        "type": "LAVA",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 62,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34379,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 62,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36921,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "DEATH_VALLEY_BATTLE_1": {
        "id": "DEATH_VALLEY_BATTLE_1",
        "type": "LAVA",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 26,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34383,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_BATTLE_2": {
        "id": "DEATH_VALLEY_BATTLE_2",
        "type": "LAVA",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 24,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34382,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_BATTLE_3": {
        "id": "DEATH_VALLEY_BATTLE_3",
        "type": "LAVA",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 25,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34381,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_CAVE_1_ENTRANCE": {
        "id": "DEATH_VALLEY_CAVE_1_ENTRANCE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 16,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DEATH_VALLEY_CAVE_1_EXIT"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34369,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_CAVE_1_EXIT": {
        "id": "DEATH_VALLEY_CAVE_1_EXIT",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 16,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DEATH_VALLEY_CAVE_1_ENTRANCE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34368,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_CAVE_2_ENTRANCE": {
        "id": "DEATH_VALLEY_CAVE_2_ENTRANCE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 20,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DEATH_VALLEY_CAVE_2_EXIT"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34371,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_CAVE_2_EXIT": {
        "id": "DEATH_VALLEY_CAVE_2_EXIT",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 19,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DEATH_VALLEY_CAVE_2_ENTRANCE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34370,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DEATH_VALLEY_RED_JAR": {
        "id": "DEATH_VALLEY_RED_JAR",
        "type": "LAVA",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 62,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34380,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 62,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36921,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "DM_BRIDGE_EXIT_E": {
        "id": "DM_BRIDGE_EXIT_E",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 5,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DM_BRIDGE_EXIT_W"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17989,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DM_BRIDGE_EXIT_W": {
        "id": "DM_BRIDGE_EXIT_W",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 4,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "DM_BRIDGE_EXIT_E"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17988,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DM_ENTRANCE": {
        "id": "DM_ENTRANCE",
        "type": "CAVE",
        "continent": 1,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 42,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_A"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18009,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "DM_EXIT": {
        "id": "DM_EXIT",
        "type": "CAVE",
        "continent": 1,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 43,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "CAVE_K"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18010,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 43,
                "mapSet": 0,
                "_metadata": {
                    "offset": 19995,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "DM_MAGIC": {
        "id": "DM_MAGIC",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 26,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24900,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "magic container",
                "number": 14,
                "mapNumber": 26,
                "mapSet": 1,
                "_metadata": {
                    "offset": 26051,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "EAST_HYRULE_BRIDGE": {
        "id": "EAST_HYRULE_BRIDGE",
        "type": "BRIDGE",
        "continent": 2,
        "worldNumber": 3,
        "mapSet": 0,
        "mapNumber": 40,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "MAZE_ISLAND_BRIDGE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24884,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_G_E_BL": {
        "id": "ELEVATOR_CAVE_G_E_BL",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 22,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_G_W_BR",
            "ELEVATOR_CAVE_G_W_TR",
            "ELEVATOR_CAVE_G_E_TL"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24873,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_G_E_TL": {
        "id": "ELEVATOR_CAVE_G_E_TL",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 23,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_G_E_BL",
            "ELEVATOR_CAVE_G_W_BR",
            "ELEVATOR_CAVE_G_W_TR"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24875,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_G_W_BR": {
        "id": "ELEVATOR_CAVE_G_W_BR",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 22,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_G_E_BL",
            "ELEVATOR_CAVE_G_W_TR",
            "ELEVATOR_CAVE_G_E_TL"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24874,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_G_W_TR": {
        "id": "ELEVATOR_CAVE_G_W_TR",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 23,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_G_E_TL",
            "ELEVATOR_CAVE_G_E_BL",
            "ELEVATOR_CAVE_G_W_BR"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24876,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_H_S_BL": {
        "id": "ELEVATOR_CAVE_H_S_BL",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 25,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_H_N_BR",
            "ELEVATOR_CAVE_H_W_TR",
            "ELEVATOR_CAVE_H_E_TL"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24879,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_H_E_TL": {
        "id": "ELEVATOR_CAVE_H_E_TL",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 24,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_H_W_TR",
            "ELEVATOR_CAVE_H_N_BR",
            "ELEVATOR_CAVE_H_S_BL"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24877,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_H_N_BR": {
        "id": "ELEVATOR_CAVE_H_N_BR",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 25,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_H_S_BL",
            "ELEVATOR_CAVE_H_E_TL",
            "ELEVATOR_CAVE_H_W_TR"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24880,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "ELEVATOR_CAVE_H_W_TR": {
        "id": "ELEVATOR_CAVE_H_W_TR",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 24,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "ELEVATOR_CAVE_H_S_BL",
            "ELEVATOR_CAVE_H_E_TL",
            "ELEVATOR_CAVE_H_N_BR"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24878,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "EX_LIFE_BEACH": {
        "id": "EX_LIFE_BEACH",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 57,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17999,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 57,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20435,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "EX_LIFE_SWAMP_1": {
        "id": "EX_LIFE_SWAMP_1",
        "type": "SWAMP",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 51,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17975,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 51,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20055,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "FAIRY_CAVE": {
        "id": "FAIRY_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 19,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "FAIRY_CAVE_HOLE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17985,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FAIRY_CAVE_HOLE": {
        "id": "FAIRY_CAVE_HOLE",
        "type": "CEMETARY",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 18,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "FAIRY_CAVE"
        ],
        "linkRequirements": {
            "FAIRY_CAVE": [
                "FAIRY"
            ]
        },
        "romMetaData": {
            "offset": 17984,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FAIRY_TOWN": {
        "id": "FAIRY_TOWN",
        "type": "TOWN",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 11,
        "passThrough": false,
        "ability": "DOWNSTAB",
        "spell": "FAIRY",
        "abilityRequirements": [
            "JUMP"
        ],
        "spellRequirements": [
            "MEDICINE"
        ],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18018,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FIRE_TOWN": {
        "id": "FIRE_TOWN",
        "type": "TOWN",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 4,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "spell": "FIRE",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34396,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FIRE_TOWN_CAVE_500P_BAG": {
        "id": "FIRE_TOWN_CAVE_500P_BAG",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 9,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34364,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 10,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36556,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "FIRE_TOWN_CAVE_ENTRANCE": {
        "id": "FIRE_TOWN_CAVE_ENTRANCE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 8,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "FIRE_TOWN_CAVE_EXIT"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34363,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FIRE_TOWN_CAVE_EXIT": {
        "id": "FIRE_TOWN_CAVE_EXIT",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 8,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "FIRE_TOWN_CAVE_ENTRANCE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34362,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FIRE_TOWN_FAIRY": {
        "id": "FIRE_TOWN_FAIRY",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 45,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34378,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "FIRE_TOWN_FOREST_500P_BAG": {
        "id": "FIRE_TOWN_FOREST_500P_BAG",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 38,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34351,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 38,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36286,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "FIRE_TOWN_RED_JAR": {
        "id": "FIRE_TOWN_RED_JAR",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 57,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34375,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 57,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36755,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "FOREST_100P": {
        "id": "FOREST_100P",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 46,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17971,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 46,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20026,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "FOREST_50P": {
        "id": "FOREST_50P",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 43,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17969,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 43,
                "mapSet": 0,
                "_metadata": {
                    "offset": 19995,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "GP": {
        "id": "GP",
        "type": "PALACE",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 7,
        "mapNumber": 0,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "completionRequirements": [
            "CRYSTALS",
            "THUNDER",
            "DOWNSTAB",
            "HANDY_GLOVE"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34405,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 41,
                "mapSet": 7,
                "_metadata": {
                    "offset": 84716,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "HAMMER_CAVE": {
        "id": "HAMMER_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 1,
        "mapSet": 1,
        "mapNumber": 15,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24872,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "hammer",
                "number": 6,
                "mapNumber": 21,
                "mapSet": 1,
                "_metadata": {
                    "offset": 25874,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "HEART_CAVE": {
        "id": "HEART_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 16,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17983,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "heart container",
                "number": 15,
                "mapNumber": 17,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20469,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "HEART_CLIFF": {
        "id": "HEART_CLIFF",
        "type": "GRASS",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 38,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17972,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "heart container",
                "number": 15,
                "mapNumber": 38,
                "mapSet": 0,
                "_metadata": {
                    "offset": 19927,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "JUMP_CAVE_N": {
        "id": "JUMP_CAVE_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 9,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "JUMP_CAVE_S"
        ],
        "linkRequirements": {
            "JUMP_CAVE_S": [
                "FAIRY | JUMP"
            ]
        },
        "romMetaData": {
            "offset": 17979,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "JUMP_CAVE_S": {
        "id": "JUMP_CAVE_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 11,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "JUMP_CAVE_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17980,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "JUMP_TOWN": {
        "id": "JUMP_TOWN",
        "type": "TOWN",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 5,
        "passThrough": false,
        "ability": "",
        "spell": "JUMP",
        "abilityRequirements": [],
        "spellRequirements": [
            "TROPHY"
        ],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18014,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "KINGS_TOMB": {
        "id": "KINGS_TOMB",
        "type": "CEMETARY",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 60,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18011,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LIFE_TOWN_BRIDGE_EW": {
        "id": "LIFE_TOWN_BRIDGE_EW",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 2,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17987,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LIFE_TOWN_BRIDGE_NS": {
        "id": "LIFE_TOWN_BRIDGE_NS",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 1,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17986,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LIFE_TOWN_FAIRY": {
        "id": "LIFE_TOWN_FAIRY",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 20,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17992,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LIFE_TOWN_N": {
        "id": "LIFE_TOWN_N",
        "type": "TOWN",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 8,
        "passThrough": false,
        "ability": "",
        "spell": "LIFE",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "LIFE_TOWN_S"
        ],
        "linkRequirements": {
            "LIFE_TOWN_S": [
                "FAIRY | JUMP | BAGU_SAUCE"
            ]
        },
        "romMetaData": {
            "offset": 18016,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LIFE_TOWN_S": {
        "id": "LIFE_TOWN_S",
        "type": "TOWN",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 6,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "LIFE_TOWN_N"
        ],
        "linkRequirements": {
            "LIFE_TOWN_N": [
                "FAIRY | JUMP"
            ]
        },
        "romMetaData": {
            "offset": 18015,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LOST_WOODS_1": {
        "id": "LOST_WOODS_1",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 44,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17973,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LOST_WOODS_2": {
        "id": "LOST_WOODS_2",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 21,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17993,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LOST_WOODS_3": {
        "id": "LOST_WOODS_3",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 22,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17994,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LOST_WOODS_4": {
        "id": "LOST_WOODS_4",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 23,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17995,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "LOST_WOODS_5": {
        "id": "LOST_WOODS_5",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 23,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17996,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAGIC_CAVE": {
        "id": "MAGIC_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 45,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17970,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "magic container",
                "number": 14,
                "mapNumber": 45,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20522,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "MAZE_ISLAND_BRIDGE": {
        "id": "MAZE_ISLAND_BRIDGE",
        "type": "BRIDGE",
        "continent": 1,
        "worldNumber": 2,
        "mapSet": 0,
        "mapNumber": 40,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "EAST_HYRULE_BRIDGE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34391,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_CHILD": {
        "id": "MAZE_ISLAND_CHILD",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 37,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24899,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "medicine",
                "number": 19,
                "mapNumber": 37,
                "mapSet": 1,
                "_metadata": {
                    "offset": 25995,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "MAZE_ISLAND_FORCED_BATTLE_1": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_1",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 35,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24882,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_2": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_2",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 34,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24881,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_3": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_3",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 47,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24901,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_4": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_4",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 49,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24903,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_5": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_5",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 50,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24904,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_6": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_6",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 51,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24905,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_FORCED_BATTLE_7": {
        "id": "MAZE_ISLAND_FORCED_BATTLE_7",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 48,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24902,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "MAZE_ISLAND_MAGIC": {
        "id": "MAZE_ISLAND_MAGIC",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 3,
        "mapSet": 3,
        "mapNumber": 36,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24883,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "magic container",
                "number": 14,
                "mapNumber": 36,
                "mapSet": 1,
                "_metadata": {
                    "offset": 26024,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "MEDICINE_CAVE": {
        "id": "MEDICINE_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17982,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "child",
                "number": 21,
                "mapNumber": 15,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20585,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "MEDICINE_CAVE_FAIRY": {
        "id": "MEDICINE_CAVE_FAIRY",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 20,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17990,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "NORTH_CASTLE": {
        "id": "NORTH_CASTLE",
        "type": "START",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 0,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17967,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "P1": {
        "id": "P1",
        "type": "PALACE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 5,
        "mapNumber": 0,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18019,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "key",
                "number": 8,
                "mapNumber": 3,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67324,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 6,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67213,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 10,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68931,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 9,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68981,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 9,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68988,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "candle",
                "number": 0,
                "mapNumber": 8,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69265,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 1,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68916,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 2,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68753,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P2": {
        "id": "P2",
        "type": "PALACE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 5,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [
            "HANDY_GLOVE"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18020,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "key",
                "number": 8,
                "mapNumber": 30,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69328,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 23,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67324,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 17,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69043,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 15,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68916,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 27,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67213,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 32,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69236,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 28,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68753,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 21,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69009,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 21,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69016,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "glove",
                "number": 1,
                "mapNumber": 20,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69274,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P2_RED_JAR": {
        "id": "P2_RED_JAR",
        "type": "SWAMP",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 57,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17997,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 57,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20435,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P3": {
        "id": "P3",
        "type": "PALACE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 6,
        "mapNumber": 0,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [
            "DOWNSTAB",
            "HANDY_GLOVE"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18021,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 1,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74220,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 2,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74044,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 2,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74051,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 4,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74044,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 4,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74051,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 5,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74673,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 8,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74096,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 12,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74220,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 13,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74758,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 7,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74137,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 7,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74148,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 10,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74632,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "raft",
                "number": 2,
                "mapNumber": 11,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75053,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 6,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75038,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P4": {
        "id": "P4",
        "type": "PALACE",
        "continent": 1,
        "worldNumber": 3,
        "mapSet": 6,
        "mapNumber": 15,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [
            "REFLECT"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 24896,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "key",
                "number": 8,
                "mapNumber": 17,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74096,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 26,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74220,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 22,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74864,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 16,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74137,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 16,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74148,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 19,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74989,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 32,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74137,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 32,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74148,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 35,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74864,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "boots",
                "number": 3,
                "mapNumber": 31,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75064,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 25,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74864,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P5": {
        "id": "P5",
        "type": "PALACE",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 5,
        "mapNumber": 35,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [
            "JUMP"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34403,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "key",
                "number": 8,
                "mapNumber": 37,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68962,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 38,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68981,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 38,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68988,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 43,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69009,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 43,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69016,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 42,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68916,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 47,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67213,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 54,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68768,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 54,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68811,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 60,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68931,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 59,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67324,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 57,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67213,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 62,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68931,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "recorder",
                "number": 4,
                "mapNumber": 61,
                "mapSet": 5,
                "_metadata": {
                    "offset": 69283,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 58,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68931,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 50,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67357,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 46,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68768,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 46,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68811,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 40,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68916,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "50p bag",
                "number": 10,
                "mapNumber": 53,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68931,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 52,
                "mapSet": 5,
                "_metadata": {
                    "offset": 67324,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 45,
                "mapSet": 5,
                "_metadata": {
                    "offset": 68753,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P5_500P_BAG": {
        "id": "P5_500P_BAG",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 33,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34374,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 33,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36317,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P5_HEART": {
        "id": "P5_HEART",
        "type": "SHALLOWS",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 7,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34361,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "heart container",
                "number": 15,
                "mapNumber": 7,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36778,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P6": {
        "id": "P6",
        "type": "PALACE",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 6,
        "mapNumber": 36,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [
            "FAIRY",
            "MAGIC_KEY"
        ],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34404,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 38,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75400,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 39,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74220,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 45,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75585,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 55,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75585,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 49,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74632,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 52,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74096,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 59,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74137,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 59,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74148,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 54,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75552,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 41,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74173,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 42,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74673,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "100p bag",
                "number": 11,
                "mapNumber": 46,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74220,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 47,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75495,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "cross",
                "number": 5,
                "mapNumber": 44,
                "mapSet": 6,
                "_metadata": {
                    "offset": 75636,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "key",
                "number": 8,
                "mapNumber": 37,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74137,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            },
            {
                "name": "200p bag",
                "number": 12,
                "mapNumber": 37,
                "mapSet": 6,
                "_metadata": {
                    "offset": 74148,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P6_500P_BAG": {
        "id": "P6_500P_BAG",
        "type": "FOREST",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 44,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34352,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 44,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36397,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "P6_HEART": {
        "id": "P6_HEART",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 46,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34377,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "heart container",
                "number": 15,
                "mapNumber": 46,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36881,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "PARAPA_CAVE_N": {
        "id": "PARAPA_CAVE_N",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 7,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "PARAPA_CAVE_S"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17977,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "PARAPA_CAVE_S": {
        "id": "PARAPA_CAVE_S",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 7,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "PARAPA_CAVE_N"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17978,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "RAFT_DOCK_E": {
        "id": "RAFT_DOCK_E",
        "type": "DOCK",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 41,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "RAFT_DOCK_W"
        ],
        "linkRequirements": {
            "RAFT_DOCK_W": [
                "RAFT"
            ]
        },
        "romMetaData": {
            "offset": 34392,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "RAFT_DOCK_W": {
        "id": "RAFT_DOCK_W",
        "type": "DOCK",
        "continent": 2,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 41,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "RAFT_DOCK_E"
        ],
        "linkRequirements": {
            "RAFT_DOCK_E": [
                "RAFT"
            ]
        },
        "romMetaData": {
            "offset": 18008,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "RED_JAR_CEM": {
        "id": "RED_JAR_CEM",
        "type": "CEMETARY",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 56,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17976,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "red jar",
                "number": 17,
                "mapNumber": 56,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20346,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "RED_JAR_SWAMP": {
        "id": "RED_JAR_SWAMP",
        "type": "SWAMP",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 51,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17991,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 51,
                "mapSet": 0,
                "_metadata": {
                    "offset": 20055,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "REFLECT_TOWN": {
        "id": "REFLECT_TOWN",
        "type": "TOWN",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 4,
        "mapNumber": 17,
        "passThrough": false,
        "ability": "UPSTAB",
        "spell": "REFLECT",
        "abilityRequirements": [
            "FAIRY | JUMP"
        ],
        "spellRequirements": [
            "CHILD"
        ],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34398,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "REFLECT_TOWN_CLIFF_1": {
        "id": "REFLECT_TOWN_CLIFF_1",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 6,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34359,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "REFLECT_TOWN_CLIFF_2": {
        "id": "REFLECT_TOWN_CLIFF_2",
        "type": "DESERT",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 23,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34360,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "SHIELD_TOWN": {
        "id": "SHIELD_TOWN",
        "type": "TOWN",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 4,
        "mapNumber": 2,
        "passThrough": false,
        "ability": "",
        "spell": "SHIELD",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 18012,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "SPELL_TOWN": {
        "id": "SPELL_TOWN",
        "type": "TOWN",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 4,
        "mapNumber": 18,
        "passThrough": false,
        "ability": "",
        "spell": "SPELL",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM",
            "LARGE_ITEM"
        ],
        "itemRequirements": [
            "SPELL",
            "MAGIC7"
        ],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34400,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "SPELL_TOWN_CAVE_ENTRANCE": {
        "id": "SPELL_TOWN_CAVE_ENTRANCE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 13,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "SPELL_TOWN_CAVE_EXIT"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34366,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "SPELL_TOWN_CAVE_EXIT": {
        "id": "SPELL_TOWN_CAVE_EXIT",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 14,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [
            "SPELL_TOWN_CAVE_ENTRANCE"
        ],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34367,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "THUNDER_TOWN": {
        "id": "THUNDER_TOWN",
        "type": "TOWN",
        "continent": 2,
        "worldNumber": 2,
        "mapSet": 4,
        "mapNumber": 23,
        "passThrough": false,
        "ability": "",
        "spell": "THUNDER",
        "abilityRequirements": [],
        "spellRequirements": [
            "MAGIC8"
        ],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34402,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "THUNDER_TOWN_CAVE_500P_BAG": {
        "id": "THUNDER_TOWN_CAVE_500P_BAG",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 11,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34365,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "500p bag",
                "number": 13,
                "mapNumber": 12,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36787,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "THUNDER_TOWN_E_BRIDGE": {
        "id": "THUNDER_TOWN_E_BRIDGE",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 1,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34358,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "THUNDER_TOWN_N_BRIDGE": {
        "id": "THUNDER_TOWN_N_BRIDGE",
        "type": "BRIDGE",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 0,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34357,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "THUNDER_TOWN_SWAMP_LIFE": {
        "id": "THUNDER_TOWN_SWAMP_LIFE",
        "type": "SWAMP",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 51,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "SMALL_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34372,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "1up",
                "number": 18,
                "mapNumber": 51,
                "mapSet": 2,
                "_metadata": {
                    "offset": 36354,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "TROPHY_CAVE": {
        "id": "TROPHY_CAVE",
        "type": "CAVE",
        "continent": 0,
        "worldNumber": 0,
        "mapSet": 0,
        "mapNumber": 33,
        "passThrough": false,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [
            "LARGE_ITEM"
        ],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 17968,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": [
            {
                "name": "trophy",
                "number": 20,
                "mapNumber": 33,
                "mapSet": 0,
                "_metadata": {
                    "offset": 19946,
                    "bitFields": [
                        {
                            "name": "collectableObjectNumber",
                            "relOffset": 2,
                            "mask": 255
                        }
                    ]
                }
            }
        ]
    },
    "WILSON_FENCE_1": {
        "id": "WILSON_FENCE_1",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 2,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34353,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "WILSON_FENCE_2": {
        "id": "WILSON_FENCE_2",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 3,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34354,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "WILSON_FENCE_3": {
        "id": "WILSON_FENCE_3",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 4,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34355,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    },
    "WILSON_FENCE_4": {
        "id": "WILSON_FENCE_4",
        "type": "PATH",
        "continent": 0,
        "worldNumber": 2,
        "mapSet": 2,
        "mapNumber": 5,
        "passThrough": true,
        "ability": "",
        "abilityRequirements": [],
        "spellRequirements": [],
        "items": [],
        "itemRequirements": [],
        "entryRequirements": [],
        "completionRequirements": [],
        "links": [],
        "linkRequirements": {},
        "romMetaData": {
            "offset": 34356,
            "fields": [
                {
                    "name": "y",
                    "relOffset": 0,
                    "mask": 127
                },
                {
                    "name": "external",
                    "relOffset": 0,
                    "mask": 128
                },
                {
                    "name": "x",
                    "relOffset": 63,
                    "mask": 63
                },
                {
                    "name": "caveSeg",
                    "relOffset": 63,
                    "mask": 64
                },
                {
                    "name": "reserved",
                    "relOffset": 63,
                    "mask": 128
                },
                {
                    "name": "mapNumber",
                    "relOffset": 126,
                    "mask": 63
                },
                {
                    "name": "hPosEnt",
                    "relOffset": 126,
                    "mask": 192
                },
                {
                    "name": "continent",
                    "relOffset": 189,
                    "mask": 3
                },
                {
                    "name": "mapSet",
                    "relOffset": 189,
                    "mask": 28
                },
                {
                    "name": "rightEnt",
                    "relOffset": 189,
                    "mask": 32
                },
                {
                    "name": "passThrough",
                    "relOffset": 189,
                    "mask": 64
                },
                {
                    "name": "fallInto",
                    "relOffset": 189,
                    "mask": 128
                }
            ]
        },
        "itemRomMetaData": []
    }
}
